import { render } from "./HeroiconsOutlineClipboardCheck.vue?vue&type=template&id=9a873d9c"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClipboardCheck.vue"]])

export default __exports__